// export const ApprovalFlowStatus = {
//   [ApprovalState.Closed]: 'Closed',
//   [ApprovalState.Cancelled]: 'Cancelled',
//   [ApprovalState.OutOfService]: 'Out of service',
// };

import { Pipe, type PipeTransform } from '@angular/core';
import { ApprovalState } from '@fdm/api-client';
import { approvalStatusNaming } from '../../utils/approval-status-naming';

@Pipe({
  name: 'appApprovalStatusNaming',
})
export class ApprovalStatusNamingPipe implements PipeTransform {
  transform(value: ApprovalState): string {
    return approvalStatusNaming(value)
  }
}
